import useSWR from 'swr';
import type { components } from 'types/api';

type User = components['schemas']['User'];
type Profile = components['schemas']['Profile'];

export interface ClassStudentProfile {
  profile_id: number;
  user_id: number;
  display_name: string;
  first_name: string;
  last_name: string;
  is_active: boolean;
}

interface ExtendedEnrolment {
  id: number;
  access_status: string;
  school_class: {
    id: number;
    title: string;
    course: {
      id: number;
      title: string;
    };
    is_active?: boolean;
  };
}
interface ExtendedProfile extends Omit<Profile, 'enrolments'> {
  enrolments: ExtendedEnrolment[];
}

export interface ExtendedUser extends Omit<User, 'profile'> {
  profile: ExtendedProfile;
}

export const useUser = (userId: number | 'me') => {
  const { data, error, isLoading } = useSWR<ExtendedUser>(
    `/api/v1/user/${userId}/`
  );

  return {
    data,
    error,
    isLoading,
  };
};
